import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';
import Icon from '../Icon';

const ButtonIcon = ({ className, iconProps, iconVariant, ...buttonProps }) => (
  <Button className={classnames('btn--icon', className)} {...buttonProps}>
    <Icon variant={iconVariant} {...iconProps} />
  </Button>
);

ButtonIcon.defaultProps = {
  variant: null
};

ButtonIcon.propTypes = () => {
  const IconPropTypes = { ...Icon.propTypes };
  delete IconPropTypes.variant;

  return {
    className: PropTypes.string,
    iconProps: PropTypes.shape(IconPropTypes),
    iconVariant: Icon.propTypes.variant,
    variant: Button.propTypes.variant
  };
};

export default ButtonIcon;
